import React from 'react';

interface TickerCellProps {
  ticker: string;
}

const TickerCell: React.FC<TickerCellProps> = ({ ticker }) => {
  return (
    <span className="text-sm text-gray-900">
      {ticker}
    </span>
  );
};

export default TickerCell; 